<template>
<div class="chapter">
<div class="inner_page">
<h2 id="heading_id_2"></h2>
<p class="center" id="cover"><img alt="God, Freedom and Human Dignity: Embracing a God-Centered Identity in a Me-Centered Culture Cover" src="Images/9780830827114.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?77473d9e